import store from '../store/index'
import { Base64 } from '../plugins/base64-1.7'
// 测试&&线上
export function getTokenPath() {
  return 'api/jwt/login'
  // return basePath + "/oauth/token?client_id=zhaopin&client_secret=123&grant_type=client_credentials";
  // return 'http://192.168.0.85:8098/oauth/token?client_id=zhaopin&client_secret=123&username=zp_user&password=123456&grant_type=password'
}

export function getRandom(){
  var str=""
  for(var i=0;i<11;i++) {
      str+= Math.floor(Math.random()*10);
  }
  return str
}

export function getTokenParamsObj() {
  var stamp = getRandom()
  return {
      userName: 'jwl',
      password: 'jwl123'
  }
}

/**
 * 清除登录信息
 */
export function clearLoginInfo () {
  // Vue.cookie.delete('Authorization')
  // Vue.cookie.delete('token')
  // store.commit('resetStore')
  // router.options.isAddDynamicMenuRoutes = false
  store.dispatch('clearLoginInfo')
}

// 将base64转换为blob
export function convertBase64UrlToBlob(urlData) {
  let arr = urlData.split(',')
  let mime = arr[0].match(/:(.*?);/)[1]
  let bstr = atob(arr[1])
  let n = bstr.length
  let u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], {type: mime})
}
//base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
export function dataURLtoFile(dataUrl, fileName){
  var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
  while(n--){
      u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], fileName, {type:mime});
}

export function compressImage(path,fileName) {

  //最大高度
  const maxHeight = 600;
  //最大宽度
  const maxWidth = 600;

  return new Promise((resolve, reject) => {
    let img = new Image();
    img.src = path;
    img.onload = function () {
      const originHeight = img.height;
      const originWidth = img.width;
      let compressedWidth = img.height;
      let compressedHeight = img.width;
      if ((originWidth > maxWidth) && (originHeight > maxHeight)) {
        // 更宽更高，
        if ((originHeight / originWidth) > (maxHeight / maxWidth)) {
          // 更加严重的高窄型，确定最大高，压缩宽度
          compressedHeight = maxHeight
          compressedWidth = maxHeight * (originWidth / originHeight)
        } else {
          //更加严重的矮宽型, 确定最大宽，压缩高度
          compressedWidth = maxWidth
          compressedHeight = maxWidth * (originHeight / originWidth)
        }
      } else if (originWidth > maxWidth && originHeight <= maxHeight) {
        // 更宽，但比较矮，以maxWidth作为基准
        compressedWidth = maxWidth
        compressedHeight = maxWidth * (originHeight / originWidth)
      } else if (originWidth <= maxWidth && originHeight > maxHeight) {
        // 比较窄，但很高，取maxHight为基准
        compressedHeight = maxHeight
        compressedWidth = maxHeight * (originWidth / originHeight)
      } else {
        // 符合宽高限制，不做压缩
      }
      // 生成canvas
      let canvas = document.createElement('canvas');
      let context = canvas.getContext('2d');
      canvas.height = compressedHeight;
      canvas.width = compressedWidth;
      context.clearRect(0, 0, compressedWidth, compressedHeight);
      context.drawImage(img, 0, 0, compressedWidth, compressedHeight);
      let base64 = canvas.toDataURL('image/*', 0.8);
      let blob = dataURLtoFile(base64,fileName);
      // 回调函数返回blob的值。也可根据自己的需求返回base64的值
      resolve({file:blob,base64:base64})
    }
  })
}

export function get_cache_size(t){
  t = t == undefined ? "l" : t;
  var obj = "";
  if(t==='l'){
      if(!window.localStorage) {
          console.log('浏览器不支持localStorage');
      }else{
          obj = window.localStorage;
      }
  }else{
      if(!window.sessionStorage) {
          console.log('浏览器不支持sessionStorage');
      }else{
          obj = window.sessionStorage;
      }
  }
  if(obj!==""){
      var size = 0;
      for(var item in obj) {
        console.log(item)
          if(obj.hasOwnProperty(item)) {
              size += obj.getItem(item).length;
          }
      }
      return (size / 1024).toFixed(2)  //单位KB
  }
}
